// --- ContactsTab.jsx ---
import { useState } from 'react';
import ContactEditModal from './editModals/ContactEditModal';

function ContactsTab({ contacts = [], vendorId, onUpdated, canEditVendors }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Contacts Persons</h5>
         {canEditVendors && (
        <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowModal(true)}>
          <i className="fa fa-edit me-1"></i> Edit Contacts
        </button>
        )}
      </div>

      {contacts.length === 0 ? (
        <p className="text-muted">No additional contacts.</p>
      ) : (
        contacts.map((c, i) => (
          <div className="border rounded p-3 mb-2 fs-85" key={i}>
            <p className="mb-1"><strong>Name:</strong> {c.name}</p>
            <p className="mb-1"><strong>Phone:</strong> {c.number}</p>
          </div>
        ))
      )}
 {canEditVendors && (
      <ContactEditModal show={showModal} onHide={() => setShowModal(false)} vendorId={vendorId} contacts={contacts} onUpdated={onUpdated} />
        )}
    </div>
  );
}

export default ContactsTab;